import { fork } from 'redux-saga/effects';

import DashboardGateway from '~apis/dashboard';
import { RootSagaReturnType } from '~types/saga';

import watchGetDashboardProductPricing from './getDashboardProductPricing';
import watchGetDashboardSilverProductPricing from './getDashboardSilverProductPricing';
import watchGetDashboardProductInventory from './getDashboardProductInventory';
import watchGetDashboardMarketStatus from './getDashboarMarketStatus';
import watchOpenDashboardMarket from './updateDashboardMarketOpen';
import watchCloseDashboardMarket from './updateDashboardMarketClose';

export default (api: DashboardGateway): RootSagaReturnType => {
    function* rootSaga() {
        yield fork(watchGetDashboardProductPricing, api);
        yield fork(watchGetDashboardSilverProductPricing, api);
        yield fork(watchGetDashboardProductInventory, api);
        yield fork(watchGetDashboardMarketStatus, api);
        yield fork(watchOpenDashboardMarket, api);
        yield fork(watchCloseDashboardMarket, api);
    }

    return {
        rootSaga,
    };
};
